import "shared/global";
import TVProviderSelector from "components/TVProviderSelector";
import {UpdateFocusable} from "components/accessibilityGeneral";

let providerSelector = new TVProviderSelector();
/*
if (typeof Vue === 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
        UpdateFocusable();
    });
}
*/
